module.exports = __webpack_public_path__ + "static/media/step2img12.86893681.JPG";